import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

import BodyPartCreateModal from "./BodyPartCreateModal";
const BodyPartHeader = () => {
  return (
    <div className="content">
      <div className="container-fluid">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ marginBottom: "24px" }}
        >
          <div className="input-group" style={{ width: "250px" }}>
            <input
              type="search"
              className="form-control rounded"
              id="name"
              placeholder="Enter Bodypart Name"
            />
            &nbsp;
          </div>
          <div>
            <BodyPartCreateModal />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BodyPartHeader;
